import IntegrationDetails from "./integrationDetailsContainer";
export default IntegrationDetails;
